import * as React from "react";

export const ImageSlider = React.forwardRef(function ImageSlider(
  { images = [], interval = 4000, showDots = true, pauseOnHover = true },
  ref
) {
  const [index, setIndex] = React.useState(0);
  const pausedRef = React.useRef(false);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    if (!images || images.length === 0) return;

    // démarre/restart le timer
    const start = () => {
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        if (!pausedRef.current) {
          setIndex((prev) => (prev + 1) % images.length);
        }
      }, interval);
    };

    start();
    return () => clearInterval(timerRef.current);
  }, [images, interval]);

  const onMouseEnter = () => { if (pauseOnHover) pausedRef.current = true; };
  const onMouseLeave = () => { if (pauseOnHover) pausedRef.current = false; };

  return (
    <div
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="relative w-full h-full"
    >
      {images && images.length > 0 ? (
        images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`slide-${i + 1}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
              i === index ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          />
        ))
      ) : (
        <div className="w-full h-full bg-gray-200 flex items-center justify-center">
          <span className="text-sm text-gray-500">Pas d'image</span>
        </div>
      )}

      {/* petits points (indicateurs) */}
      {showDots && images && images.length > 1 && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-4 flex gap-2">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Aller à la slide ${i + 1}`}
              className={`w-2.5 h-2.5 rounded-full transform transition ${
                i === index ? "bg-white scale-100" : "bg-white/60 hover:scale-110"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
});

ImageSlider.displayName = "ImageSlider";